<template>
  <template v-if="componentLoading">
    <Loading :style="style" />
  </template>
  <view v-else class="pft-list-1" :style="style">
    <view v-if="data.length === 0" class="empty-container">暂无数据</view>
    <view v-else class="list-list" :flex="flex">
      <view class="list-item" v-for="item of data" v-bind:key="item.name" flex="dir:left main:justify cross:center" :style="itemStyle">
        <view flex="dir:left cross:center" class="list-item-inner">
          <view class="item-rate" :style="Object.assign(cloneDeep(rateStyle), { width: `${item.rate}%` })" />
          <view class="item-name" :style="nameStyle">{{ item.name }}</view>
          <view class="item-count" :style="countStyle">{{ item.count }} {{ suffix }}</view>
        </view>
        <view v-if="showRate" class="item-rate-num"> {{ item.rate }}% </view>
      </view>
    </view>
  </view>
</template>
<script lang="ts" setup>
import { ref } from "vue"
import Loading from "@p-v/packages/Loading.vue"
import { cloneDeep } from "lodash-es"

defineOptions({
  name: "List1",
})
interface List1Props {
  style?: { [key: string]: string }
  flex?: string
  suffix?: string | undefined
  itemStyle?: { [key: string]: string | number }
  nameStyle?: { [key: string]: string | number }
  countStyle?: { [key: string]: string | number }
  rateStyle?: { [key: string]: string | number }
  showRate?: boolean
}

interface ListDataItem {
  name: string
  count: number
  rate: number
}

const componentLoading = ref<boolean>(true)
const data = ref<ListDataItem[]>([])

withDefaults(defineProps<List1Props>(), {
  style: () => ({}),
  flex: () => "dir:top main:center cross:left",
  suffix: undefined,
  itemStyle: () => ({}),
  nameStyle: () => ({}),
  countStyle: () => ({}),
  rateStyle: () => ({}),
  showRate: () => false,
})

const loading = () => {
  componentLoading.value = true
}

const setData = (val: ListDataItem[]) => {
  // console.log("setData val", val)
  componentLoading.value = false
  data.value = val
}

defineExpose({ loading, setData })
</script>
<style lang="scss">
.pft-list-1 {
  box-sizing: border-box;
  height: 100%;
  .list-list {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;
    gap: 10px;
    scrollbar-width: none; /* Firefox */
    scrollbar-color: rgba(0, 0, 0, 0.5) transparent; /* Firefox */

    /* Webkit 浏览器（Chrome, Safari） */
    &::-webkit-scrollbar {
      width: 0px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.5);
      border-radius: 4px;
      transition: background-color 0.3s;
    }
    &::-webkit-scrollbar-thumb:hover {
      background-color: rgba(0, 0, 0, 0.7);
    }
  }
  .list-item {
    position: relative;
    height: 20px;
    line-height: 20px;
    .list-item-inner {
      position: relative;
      flex-grow: 1;
    }
    .item-name {
      position: relative;
      font-family:
        Segoe UI,
        Segoe UI;
      font-weight: 400;
      font-size: 12px;
      color: #ffffff;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      width: 10px;
      text-align: left;
      flex-grow: 1;
    }
    .item-count {
      position: relative;
      font-family:
        Segoe UI,
        Segoe UI;
      font-weight: 400;
      font-size: 12px;
      color: #ffffff;
      margin-left: 24px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .item-rate {
      background: #fff;
      position: absolute;
      top: 0;
      left: 0;
      width: 0;
      height: 100%;
      background: rgba(43, 151, 247, 0.65);
    }
    .item-rate-num {
      font-family:
        Segoe UI,
        Segoe UI;
      font-weight: 400;
      font-size: 12px;
      color: #fcf072;
      line-height: 20px;
      text-align: right;
      margin-left: 16px;
    }
  }
  .empty-container {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: rgba(163, 166, 173, 0.6431372549);
  }
}
</style>
